import { EventEmitter } from '@angular/core';
import { NewInfluencer, NewInfluencerChanel } from '../../../../models/influencer/new-influencer';
import { CommonConstant, listOrderedPlatforms, platformIconPath, platformIconPathById } from '../../../app.constants';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { InfluencerGroup } from '../../../../models/influencer-group';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { AchooFilterBoxComponent } from '../../../core/achoo-filter-box/achoo-filter-box.component';
import { ModalService } from '../../../services/modal/modal.service';
import { InfluencerSuggestion, InfluencerSuggestionState } from '../../../../models/influencer-suggestion';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
var AddInfluencerManuallyComponent = /** @class */ (function () {
    function AddInfluencerManuallyComponent(influencerService, referenceService, validationErrorHandler, modalService) {
        this.influencerService = influencerService;
        this.referenceService = referenceService;
        this.validationErrorHandler = validationErrorHandler;
        this.modalService = modalService;
        this.closeFragmentAddInfluencerManually = new EventEmitter();
        this.errorWhenCreatingNewInfluencer = new EventEmitter();
        this.newInfluencer = new NewInfluencer();
        this.influencerChannels = [];
        this.listPlatform = [];
        this.fieldErrors = [];
    }
    AddInfluencerManuallyComponent.prototype.ngOnInit = function () {
        var _this = this;
        listOrderedPlatforms.forEach(function (channel) {
            _this.listPlatform.push({
                id: channel.id,
                name: channel.name
            });
        });
        // instagram is mandatory and default channel
        var igChannel = new NewInfluencerChanel(platformIconPath.instagram.id);
        igChannel.handle = this.removeAtSign(this.influencerSuggestion.influencerName);
        this.influencerChannels.push(igChannel);
        this.newInfluencer.activeChannels.push(igChannel.platform_id);
    };
    AddInfluencerManuallyComponent.prototype.deleteInfluencerProfile = function (platformId) {
        var deleteChannelIndex = this.influencerChannels.findIndex(function (channel) { return channel.platform_id === platformId; });
        this.influencerChannels.splice(deleteChannelIndex, 1);
        var deleteActiveChannelIndex = this.newInfluencer.activeChannels.findIndex(function (ac) { return ac === platformId; });
        this.newInfluencer.activeChannels.splice(deleteActiveChannelIndex, 1);
        this.platformList.updateModel(this.newInfluencer.activeChannels);
    };
    AddInfluencerManuallyComponent.prototype.trackInfluencerChannel = function (index, channel) {
        return index;
    };
    AddInfluencerManuallyComponent.prototype.closeAddInfluencerManuallyFragment = function () {
        this.closeConfirmationPopup();
        this.internalCloseFragment();
    };
    AddInfluencerManuallyComponent.prototype.internalCloseFragment = function (influencer) {
        this.closeFragmentAddInfluencerManually.emit(influencer);
    };
    AddInfluencerManuallyComponent.prototype.addNewInfluencer = function () {
        var _this = this;
        var errors = this.influencerService.validateInfluencerData(this.newInfluencer, this.influencerChannels);
        if (errors.length > 0) {
            this.fieldErrors = errors;
            this.validationErrorHandler.shouldDisplayErrors(true);
            this.validationErrorHandler.updateErrors(errors);
            return;
        }
        // Remove the @ sign
        this.influencerSuggestion.influencerName = this.removeAtSign(this.influencerSuggestion.influencerName);
        this.influencerChannels[0].handle = this.removeAtSign(this.influencerChannels[0].handle);
        // show on UI status of adding new influencer
        this.influencerSuggestion.state = InfluencerSuggestionState.PROCESSING;
        this.influencerSuggestion.id = -1;
        this.internalCloseFragment(this.influencerSuggestion);
        this.influencerService.addInfluencerByHandle(this.newInfluencer, this.influencerChannels).subscribe(function (res) {
            var existingInfluencer = res.data;
            _this.newInfluencer.name = existingInfluencer.name;
            _this.newInfluencer.country = existingInfluencer.country ? existingInfluencer.country.id : null;
            _this.newInfluencer.languages = _this.extractLanguages(existingInfluencer.influencerLanguages);
            _this.newInfluencer.activeChannels = _this.extractActiveChannels(existingInfluencer.influencerChannels);
            _this.newInfluencer.status = existingInfluencer.status;
            _this.newInfluencer.gender = existingInfluencer.gender;
            _this.newInfluencer.email = existingInfluencer.email;
            _this.newInfluencer.systemEmail = existingInfluencer.systemEmail;
            _this.afterAddingInfluencerSuccess(existingInfluencer);
        }, function (err) {
            var influencerData = Object.assign({}, _this.newInfluencer, {
                languages: _this.newInfluencer.languages || [CommonConstant.INTERNATIONAL_LANGUAGE]
            });
            if (_this.newInfluencer.country) {
                influencerData = Object.assign({}, influencerData, {
                    country: _this.newInfluencer.country
                });
            }
            _this.influencerService.addNewInfluencer(influencerData, _this.influencerChannels, _this.afterAddingInfluencerSuccess.bind(_this), _this.onErrorOccurred.bind(_this));
        });
    };
    AddInfluencerManuallyComponent.prototype.extractLanguages = function (influencerLanguages) {
        if (Array.isArray(influencerLanguages) && influencerLanguages.length === 0) {
            return [];
        }
        return influencerLanguages.map(function (il) { return il.language ? il.language.id : 0; });
    };
    AddInfluencerManuallyComponent.prototype.extractActiveChannels = function (influencerChannels) {
        if (Array.isArray(influencerChannels) && influencerChannels.length === 0) {
            return [];
        }
        return influencerChannels.map(function (ic) { return ic.platform_id; });
    };
    AddInfluencerManuallyComponent.prototype.afterAddingInfluencerSuccess = function (influencer) {
        this.modalService.open(this.notificationAfterAddingNewInfluencerSuccess, undefined, true);
        this.influencerSuggestion.id = influencer.id;
        this.influencerSuggestion.influencerId = influencer.id;
        this.influencerSuggestion.channels = this.influencerChannels.map(function (c) { return ({
            platform_id: c.platform_id,
            handle: c.handle
        }); });
        this.influencerSuggestion.influencerName = influencer.domain;
        this.influencerSuggestion.countryCode = influencer.country.code;
        this.influencerSuggestion.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
    };
    AddInfluencerManuallyComponent.prototype.onErrorOccurred = function (err) {
        this.influencerSuggestion.state = InfluencerSuggestionState.ERROR;
        this.errorWhenCreatingNewInfluencer.emit({
            newInfluencer: this.newInfluencer,
            influencerChannels: this.influencerChannels
        });
    };
    Object.defineProperty(AddInfluencerManuallyComponent.prototype, "countryList", {
        get: function () {
            return this.referenceService.countries;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddInfluencerManuallyComponent.prototype, "languageList", {
        get: function () {
            return this.referenceService.languages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddInfluencerManuallyComponent.prototype, "genderError", {
        get: function () {
            var genderErr = this.fieldErrors.find(function (err) { return err.name === 'newInfluencer.gender'; });
            return genderErr;
        },
        enumerable: true,
        configurable: true
    });
    AddInfluencerManuallyComponent.prototype.findChannelNameById = function (channelId) {
        var channel = platformIconPathById[channelId];
        return channel ? channel.name.toLowerCase() + '-channel' : '';
    };
    AddInfluencerManuallyComponent.prototype.getPrefixByPlatform = function (platformId) {
        var channel = platformIconPathById[platformId];
        return channel ? channel.prefix : '';
    };
    AddInfluencerManuallyComponent.prototype.channelFormName = function (channelId) {
        var channel = platformIconPathById[channelId];
        return channel ? channel.name.toLowerCase() + '.handle' : null;
    };
    AddInfluencerManuallyComponent.prototype.onSelectChannel = function (evt) {
        var _this = this;
        // keep all already selected channels
        this.influencerChannels = this.influencerChannels.filter(function (p) { return _this.newInfluencer.activeChannels.indexOf(p.platform_id) >= 0; });
        // extract id
        var alreadySelectedChannelIds = this.influencerChannels.map(function (c) { return c.platform_id; });
        // find list of new added channels
        var newAddedChannels = this.newInfluencer.activeChannels.filter(function (sc) { return alreadySelectedChannelIds.indexOf(sc) < 0; })
            .map(function (c) {
            var newChannel = new NewInfluencerChanel(c);
            if (c === platformIconPath.tiktok.id) {
                newChannel.handle = '@';
            }
            return newChannel;
        });
        (_a = this.influencerChannels).push.apply(_a, newAddedChannels);
        var _a;
    };
    AddInfluencerManuallyComponent.prototype.onSelectGender = function (evt) {
        this.fieldErrors = this.fieldErrors.filter(function (err) { return err.name !== 'newInfluencer.gender'; });
    };
    AddInfluencerManuallyComponent.prototype.closeConfirmationPopup = function () {
        this.modalService.close();
    };
    AddInfluencerManuallyComponent.prototype.openConfirmationBeforeExisting = function () {
        this.modalService.openInCenter(this.confirmationBeforeExistingNewInfluencerFragment);
    };
    AddInfluencerManuallyComponent.prototype.removeAtSign = function (influencerItemName) {
        var itemName = influencerItemName ? influencerItemName.toString().trim() : '';
        if (itemName.startsWith('@')) {
            return itemName.substring(1);
        }
        return itemName;
    };
    return AddInfluencerManuallyComponent;
}());
export { AddInfluencerManuallyComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/add-influencer-manually/add-influencer-manually.component.ts.pre-build-optimizer.js